export enum ExternalLinks {
  SpotlightTermsAndConditions = "https://www.spotlight.com/the-small-print/terms-conditions/",
}
